import React, { useMemo } from 'react';

import { CheckboxGroup } from '@eika/checkbox';
import { Input } from '@eika/input';
import { WarningLabel } from '@eika/label';

import useTranslation from '../../../../hooks/useTranslation';
import { transactionTrackIDs } from '../../../../utils/gtm/trackIDs/transaction';
import { AmountRangeInput } from '../AmountRangeInput';
import FilterDateRangeInput from '../FilterDateRangeInput/FilterDateRangeInput';
import { useTransactionFilterContext } from '../TransactionFilterContext/TransactionFilterContext';
import { TransactionModalContentProps } from './modalTypes';

const MAX_FREETEXT_LENGTH = 32;

const DesktopTransactionFilterModalContent: React.FC<TransactionModalContentProps> = ({ targetCurrency }) => {
    const translation = useTranslation();
    const { transactionCategory, isFreetextSearch, freetext, isCategorySearch, minAmount, maxAmount, moneyDirection } =
        useTransactionFilterContext();

    const categoryCheckboxes = useMemo(() => {
        return transactionCategory.data.map((category) => ({
            ...category,
            checked: transactionCategory.value.includes(category.value),
            'data-track-id': transactionTrackIDs.search.id,
            'data-track-linkname': category.value,
        }));
    }, [transactionCategory]);

    return (
        <>
            {isFreetextSearch && (
                <Input
                    className="transaction-filter-form__freetext-input"
                    type="search"
                    placeholder={translation.transactionFilter.freetextPlaceholder}
                    value={freetext.value ?? ''}
                    onChange={(e) => freetext.set(e.target.value)}
                    label={translation.transactionFilter.search}
                    maxLength={MAX_FREETEXT_LENGTH}
                />
            )}
            <FilterDateRangeInput />

            <AmountRangeInput
                contentWrapperClassName="transaction-filter-form__amount-range-wrapper"
                mainLabel={translation.transactionFilter.chooseAmount}
                moneyDirection={moneyDirection}
                fromAmount={{
                    value: minAmount.value,
                    onChange: minAmount.set,
                    label: translation.transactionFilter.from,
                    id: 'min-amount',
                    name: 'transaction-filter-min-amount',
                }}
                toAmount={{
                    value: maxAmount.value,
                    onChange: maxAmount.set,
                    label: translation.transactionFilter.to,
                    id: 'max-amount',
                    name: 'transaction-filter-max-amount',
                }}
                currency={targetCurrency}
            />
            {transactionCategory.data && isCategorySearch && (
                <>
                    <CheckboxGroup
                        checkboxWrapperClassName="transaction-filter-form__category-wrapper"
                        label={translation.transactionFilter.chooseCategory}
                        options={categoryCheckboxes}
                    />
                    {transactionCategory.warningMessage && <WarningLabel text={transactionCategory.warningMessage} />}
                </>
            )}
        </>
    );
};

export default DesktopTransactionFilterModalContent;
